import React from "react";
import { YOUTUBE, VIMEO } from "../../../services/constants/VideoPlatforms";

const VideoPreview = ({ type, videoId, width, height, autoplay }) => {
    const autoplayParam = `?autoplay=` + (autoplay ? `1` : `0`);
    const videoSrc = `${type === 'youtube' ? YOUTUBE : VIMEO}${videoId}${autoplayParam}`;

    return (
        <iframe
            title={`${type} video`}
            width={width}
            height={height}
            src={videoSrc}
            allow="autoplay; encrypted-media"
            allowFullScreen
        />
    );
};

export default VideoPreview;
